export default "__VITE_ASSET__6d44d210__"